import React, { useEffect, useState, useRef } from "react";
import tab_img01 from "../../src/images/tab-img01.png";
import tab_img02 from "../../src/images/tab-img06.png";
import tab_img03 from "../../src/images/tab-img02.png";
import tab_img04 from "../../src/images/tab-img04.png";
import tab_img05 from "../../src/images/tab-img05.png";

export default function Horizontal() {
  const duration = 8000;
  const timerRef = useRef(null);

  const tabs = [
    {
      title: "Full Truck Load / Part Truck Load",
      content: "Move large shipments efficiently with FTL and PTL solutions. Ideal for bulk goods, ensuring cost-effective transportation across long distances.",
      img: tab_img01,
    },
    {
      title: "Express Delivery",
      content: "Deliver urgent shipments faster with priority courier services. Perfect for time-sensitive orders that require quick and reliable delivery.",
      img: tab_img02,
    },
    {
      title: "Same Day & Next Day",
      content: "Get orders delivered within hours or by the next day. Ideal for businesses that need ultra-fast fulfillment and improved customer satisfaction.",
      img: tab_img03,
    },
    {
      title: "Appointment Based Deliveries",
      content: "Schedule deliveries at a convenient time for the recipient. Perfect for high-value or bulky shipments that require planned delivery.",
      img: tab_img04,
    },
    {
      title: "Reverse Pickup",
      content: "Simplify returns with hassle-free reverse pickup services. Collect packages from customers and send them back to the seller smoothly.",
      img: tab_img05,
    },
  ];

  const [activeIndex, setActiveIndex] = useState(0);
  const [progress, setProgress] = useState(0);

  // Progress animation
  useEffect(() => {
    setProgress(0);

    const start = Date.now();

    const interval = setInterval(() => {
      const elapsed = Date.now() - start;
      const percent = Math.min((elapsed / duration) * 100, 100);
      setProgress(percent);

      if (percent === 100) {
        clearInterval(interval);
      }
    }, 50);

    return () => clearInterval(interval);
  }, [activeIndex]);

  // Tab auto change
  useEffect(() => {
    timerRef.current = setTimeout(() => {
      setActiveIndex((prev) => (prev + 1) % tabs.length);
    }, duration);

    return () => clearTimeout(timerRef.current);
  }, [activeIndex]);

  const handleClick = (index) => {
    clearTimeout(timerRef.current);
    setActiveIndex(index);
  };
  const accordionData = [
    {
      id: "One",
      title: "Full Truck Load / Part Truck Load",
      description:
        "Move large shipments efficiently with FTL and PTL solutions. Ideal for bulk goods, ensuring cost-effective transportation across long distances.",
      img: tab_img01,
      show: true,
    },
    {
      id: "Two",
      title: "Express Delivery",
      description:
        "Deliver urgent shipments faster with priority courier services. Perfect for time-sensitive orders that require quick and reliable delivery.",
      img: tab_img02,
    },
    {
      id: "Three",
      title: "Same Day & Next Day",
      description:
        "Get orders delivered within hours or by the next day. Ideal for businesses that need ultra-fast fulfillment and improved customer satisfaction.",
      img: tab_img03,
    },
    {
      id: "Four",
      title: "Appointment Based Deliveries",
      description:
        "Schedule deliveries at a convenient time for the recipient. Perfect for high-value or bulky shipments that require planned delivery.",
      img: tab_img04,
    },
    {
      id: "Five",
      title: "Reverse Pickup",
      description:
        "Simplify returns with hassle-free reverse pickup services. Collect packages from customers and send them back to the seller smoothly.",
      img: tab_img05,
    },
  ];
  return (
    <>
      <div className="d-md-block d-none">
        <div className="row justify-content-end m-0 mt-5">
          <div className="col-md-5 mx-auto">
            <div className="nav flex-column nav-pills">
              {tabs.map((tab, index) => (
                <button
                  key={index}
                  className={`nav-link ${
                    activeIndex === index ? "active" : ""
                  }`}
                  onClick={() => handleClick(index)}
                >
                  {tab.title}

                  <div className="tab-progress-wrapper">
                    <div
                      className="tab-progress-bar"
                      style={{
                        width:
                          activeIndex === index ? `${progress}%` : "0%",
                      }}
                    ></div>
                  </div>

                  <p>{tab.content}</p>
                </button>
              ))}
            </div>
          </div>

          <div className="col-md-6 text-end pe-0">
            <img
              src={tabs[activeIndex].img}
              alt=""
              className="img-fluid tab-img"
            />
          </div>
        </div>
      </div>
      <div className="accordion d-md-none d-block accordion-responsive" id="accordionExample">
        {accordionData.map((item, index) => (
          <div className="accordion-item" key={item.id}>
            <h2 className="accordion-header" id={`heading${item.id}`}>
              <button
                className={`accordion-button ${!item.show ? "collapsed" : ""}`}
                type="button"
                data-bs-toggle="collapse"
                data-bs-target={`#collapse${item.id}`}
                aria-expanded={item.show ? "true" : "false"}
                aria-controls={`collapse${item.id}`}
              >
                <div>
                  <strong>{item.title}</strong>
                  <p className="mb-0">{item.description}</p>
                </div>
              </button>
            </h2>

            <div
              id={`collapse${item.id}`}
              className={`accordion-collapse collapse ${
                item.show ? "show" : ""
              }`}
              aria-labelledby={`heading${item.id}`}
              data-bs-parent="#accordionExample"
            >
              <div className="accordion-body">
                <img
                  src={item.img}
                  alt={item.title}
                  className="img-fluid tab-img"
                />
              </div>
            </div>
          </div>
        ))}
      </div>
    </>
  );
}